import React from "react";
import "./App.scss";
import { BrowserRouter as Router } from "react-router-dom";
import Config from "config/Config";

function App() {
  return (
    <div className="App">
      <Router>
        <Config />
      </Router>
    </div>
  );
}

export default App;
